// The standalone instance, so a plain URL builder (buildOutboxCampaignHref) can write the same item.
import i18n from "@/i18n";

import { ALL_SENDERS_ID } from "./outboxSenderId";

import type { DropdownWithCheckboxesItem } from "@/components/DropdownWithCheckboxes/DropdownWithCheckboxes";

export { ALL_SENDERS_ID };

/**
 * The sender filter's "All" item, as the Outbox writes it to its state and the URL. One source, so a
 * link into the Outbox (PREC-4291) writes exactly what the Outbox itself would.
 */
export const allSendersItem = (): DropdownWithCheckboxesItem => ({
	id: ALL_SENDERS_ID,
	title: i18n.t("outbox.filters.allSenders"),
});

/** The sender filter's label for the viewer: "Me (First Last)". */
export const meSenderTitle = (
	user: { firstName?: string | null; lastName?: string | null } | null | undefined
): string => i18n.t("outbox.filters.meSender", { name: `${user?.firstName} ${user?.lastName}` });
